import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const footerLinks = [
  ["Início", "/", "footer-home-link"],
  ["Serviços", "/servicos", "footer-services-link"],
  ["Sobre Nós", "/sobre-nos", "footer-about-link"],
  ["Contactos", "/contactos", "footer-contact-link"],
  ["FAQ", "/faq", "footer-faq-link"],
  ["Marcar Serviço", "/marcar-servico", "footer-book-link"],
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-main">
        <div className="footer-brand-block">
          <Link to="/" className="footer-brand" data-testid="footer-brand-link"><span className="footer-logo-wrap"><img className="footer-logo" src="/problema360-logo.png" alt="Problema360 Porto" /></span></Link>
          <p>Serviços para a sua casa em Porto e arredores.</p>
          <Link to="/marcar-servico" className="footer-action" data-testid="footer-book-action-link">Diga-nos o que precisa <ArrowUpRight size={16} /></Link>
        </div>
        <div className="footer-column">
          <span className="footer-label">Navegação</span>
          {footerLinks.map(([label, to, testId]) => <Link key={to} to={to} data-testid={testId}>{label}</Link>)}
        </div>
        <div className="footer-column">
          <span className="footer-label">Informação</span>
          <Link to="/privacidade" data-testid="footer-privacy-link">Política de Privacidade</Link>
          <Link to="/termos" data-testid="footer-terms-link">Termos e Condições</Link>
          <Link to="/cookies" data-testid="footer-cookies-link">Política de Cookies</Link>
          <Link to="/admin" data-testid="footer-admin-link">Área interna</Link>
        </div>
      </div>
      <div className="container footer-bottom">
        <span>© Problema360. Todos os direitos reservados.</span>
        <span>Porto, Portugal</span>
      </div>
    </footer>
  );
}
